import React from 'react';
import { observer } from 'mobx-react';
import classes from 'classnames';
import {
    AnswerableToggleButton,
    AnswerableToggleButtonGroup,
} from './components/buttons';
import { useTranslation } from 'react-i18next';
import { translatableResourcePath } from '../../utils/helpers';
import { QuestionHeading } from './question-heading';

export const Questionwithbuttons = observer(
    ({ ui, handleChange, value, answer }) => {
        const { t } = useTranslation('assessment');
        const handleToggle = (event, newValue) => {
            handleChange(newValue);
        };

        return (
            <div className={classes('assessment')}>
                <div className={'assessment-question seperate-buttons'}>
                    {ui.image && (
                        <div className="image fullwidth">
                            <img
                                src={translatableResourcePath(ui.image, t)}
                                alt="illustration"
                            />
                        </div>
                    )}
                    <QuestionHeading ui={ui} />
                    <br />
                    <AnswerableToggleButtonGroup
                        handleToggle={handleToggle}
                        value={value}
                        fullWidth={true}
                    >
                        {ui.options.map((v, i) => {
                            return (
                                <AnswerableToggleButton
                                    key={'select-' + i}
                                    name={'select-' + i}
                                    value={v.value}
                                    text={t(v.text)}
                                    answer={answer}
                                    selected={value === v.value}
                                    handleToggle={handleToggle}
                                    oneOf={ui.options.length} //How many buttons in total, used to give them equal width
                                />
                            );
                        })}
                    </AnswerableToggleButtonGroup>
                </div>
            </div>
        );
    }
);
